import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { patchAcceptRejectDecodedPlateVIN } from 'actions/vehicles'
import { DrivingProfile, ProfileVehicle } from 'types/profile'
import { ModalOptions } from 'types/global'

type UsePendingPlateLookupModalViewModelProps = {
  vehicle: ProfileVehicle
  setModalOptions: React.Dispatch<React.SetStateAction<ModalOptions>>
}

export const usePendingPlateLookupModalViewModel = (props: UsePendingPlateLookupModalViewModelProps) => {
  const { vehicle, setModalOptions } = props
  const profile = useSelector<any, DrivingProfile>((state) => state.profile)
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleAccept = useCallback(async () => {
    await patchAcceptRejectDecodedPlateVIN(profile.id, vehicle.details.id, 'accept')(dispatch)
    history.push(`/account/driving-info/vehicle-info/${vehicle.details.id}`, { skipPendingPlateModal: true })
  }, [profile.id, vehicle.details.id, dispatch, history])

  const handleAddInsurance = useCallback(() => {
    setModalOptions({ modalOpen: true, modalType: 'add-insurance' })
  }, [setModalOptions])

  const handleClose = useCallback(() => {
    setModalOptions({ modalOpen: false, modalType: null })
  }, [setModalOptions])

  return {
    isWebView,
    handleAccept,
    handleAddInsurance,
    handleClose,
  }
}
